import { Children, isValidElement, ReactElement } from 'react';

import { BodyLarge, BodyRegular, BodySmall } from '@common/body';

type ChildType = ReactElement<
  typeof BodyLarge | typeof BodyRegular | typeof BodySmall
>;

const getIsBodyElement = (child: ChildType): boolean =>
  !!(
    child.type === BodyLarge ||
    child.type === BodyRegular ||
    child.type === BodySmall
  );

export const BodyParagraphs = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => (
  <div>
    {Children.map(children, (child, i) => {
      if (isValidElement(child) && getIsBodyElement(child as ChildType)) {
        const className = i === 0 ? '' : 'mt-3';
        return <div className={className}>{child}</div>;
      }
    })}
  </div>
);
